import { SxProps, Theme } from "@mui/system";

export function wrapper(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "white",
        zIndex: 5,
        my: 2,
        borderRadius: "15px",
        border: "1px solid black",
        maxWidth: "1200px",
        backgrounColor: "white",
        width: "100%",
    };
}

export function statusWrapper(theme: Theme): SxProps<Theme> {
    return {
        border: "2px solid lightgray",
        backgroundColor: "#f1f1f1",
        padding: "10px",
        borderRadius: "10px",
    };
}

export function selectProcessorWrapper(theme: Theme): SxProps<Theme> {
    return {
        marginTop: "15px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
    };
}

export function selectProcessor(theme: Theme): SxProps<Theme> {
    return {
        minWidth: "120px",
    };
}

export function statusButton(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        maxWidth: "200px",
        margin: "5px",
    };
}
